import { actionsFactory } from '@eas/common-web';

export const Actions = actionsFactory('/api/crzp/actions', null, []);
